// extracted by mini-css-extract-plugin
export default {"main":"Cuestionario_main__CrksW","submit":"Cuestionario_submit__FGRFd","highlight":"Cuestionario_highlight__s4aTC","message":"Cuestionario_message__JJlnY"};